import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-396781b0")
const _hoisted_1 = { id: "colors-component" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " Pick a custom color", -1)
const _hoisted_3 = {
  class: "color",
  ref: "customColor"
}
const _hoisted_4 = { id: "colors-wrap" }
const _hoisted_5 = { id: "colors-select" }
const _hoisted_6 = ["onClick"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTitle = _resolveComponent("ToolTitle")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ToolTitle, { title: _ctx.title }, null, 8, ["title"]),
    _createElementVNode("div", {
      id: "custom-color",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openColorPickr && _ctx.openColorPickr(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, {
        class: "tool-icon",
        icon: "fill-drip",
        "aria-hidden": "true"
      }),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, null, 512)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (color) => {
          return (_openBlock(), _createElementBlock("div", {
            key: color.title,
            style: _normalizeStyle({ backgroundColor: '#' + color.hex }),
            class: "color",
            onClick: ($event: any) => (_ctx.chooseColor('#' + color.hex))
          }, null, 12, _hoisted_6))
        }), 128))
      ])
    ])
  ]))
}